export const blogsTypes = {
  FETCH_BLOGS_LOADING: "FETCH_BLOGS_LOADING",
  FETCH_BLOGS_SUCCESS: "FETCH_BLOGS_SUCCESS",
  FETCH_BLOGS_FAILURE: "FETCH_BLOGS_FAILURE",

  FETCH_BLOG_BY_ID_LOADING: "FETCH_BLOG_BY_ID_LOADING",
  FETCH_BLOG_BY_ID_SUCCESS: "FETCH_BLOG_BY_ID_SUCCESS",
  FETCH_BLOG_BY_ID_FAILURE: "FETCH_BLOG_BY_ID_FAILURE",
};
